import React from "react";

/**
 * Recommended Icon (for Recommended/Tinder-style page)
 * Follows the shared icon pattern: gradient stroke, active weight, size via className
 */
const RecommendedIcon = ({
  className = "w-7 h-7",
  isActive = false,
  ...props
}) => {
  const gradientId = `primaryGradientRecommended-${React.useId()}`;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${className} flex-shrink-0`}
      {...props}
    >
      <defs>
        <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#FFE48A" />
          <stop offset="50%" stopColor="var(--color-primary)" />
          <stop offset="100%" stopColor="#A87A1F" />
        </linearGradient>
      </defs>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={isActive ? "2" : "1.5"}
        stroke={`url(#${gradientId})`}
        d="M7.5 21 3 16.5m0 0L7.5 12M3 16.5h13.5m0-13.5L21 7.5m0 0L16.5 12M21 7.5H7.5"
      />
    </svg>
  );
};

export default RecommendedIcon;
